import styled from "styled-components";

interface JackpotBetWinHighlightProps {
  margin?: string;
  width?: string;
  height?: string;
}
export const JackpotBetWinHighlightDefaultBox = styled.div<JackpotBetWinHighlightProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: ${({ margin }) => margin || "1rem 6px 2.4rem 0px"};
    width: ${({ width }) => width || "310px"};
    height: ${({ height }) => height || "130px"};
    align-self: center;
    /* width: fit-content;
    align-self: center; */

    box-shadow: 
        0px 0px 20px 0px #7FF80080 inset,
        0px 0px 30px 2px #7FF800BF,
        0px 0px 40px 0px #FFE60166 inset;



    background-color: #22004d; 
    background-image: radial-gradient( #9747ff 2%, #22004d 40%);

    border-radius: 90px;
    border: 2px solid #7FF800;
`